// project-imports
import Default from './default';
import Theme1 from './theme1';

import {ThemeMode} from '../../configs/themeConfig';

// types
import {PaletteThemeProps, PresetColor} from '../../types';

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

export const Theme = (presetColor: PresetColor, mode: ThemeMode): PaletteThemeProps => {
    switch (presetColor) {
        case 'theme1':
            return Theme1(mode);
        default:
            return Default(mode);
    }
};

export default Theme;
